import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import { IFarmsDto } from "../shared";

export const farmsApi = createApi({
  reducerPath: "farmsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchFarms: builder.query<IFarmsDto[], void>({
      queryFn: pagedQueryFn<IFarmsDto, IFarmsDto[]>({ url: "FarmsV2" }, (dtos) =>
        dtos.sort((prev, next) => prev.name.localeCompare(next.name))
      ),
    }),
  }),
});

export const { useFetchFarmsQuery } = farmsApi;
export const farmsApiReducer = farmsApi.reducer;
